import { render, staticRenderFns } from "./TempChangePassword.vue?vue&type=template&id=6be87b1c"
import script from "./TempChangePassword.vue?vue&type=script&lang=js"
export * from "./TempChangePassword.vue?vue&type=script&lang=js"
import style0 from "./TempChangePassword.vue?vue&type=style&index=0&id=6be87b1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports